import { render } from "./Modal-Workbook.vue?vue&type=template&id=5e104e9b&scoped=true"
import script from "./Modal-Workbook.vue?vue&type=script&lang=js"
export * from "./Modal-Workbook.vue?vue&type=script&lang=js"

import "./Modal-Workbook.vue?vue&type=style&index=0&id=5e104e9b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e104e9b"]])

export default __exports__